// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2mIA3","list":"styles_list__2SRfP"};